import authType from '@/config/authType';
import util from '@/config/util';
const config = {
  instStatusMap: [
    { name: '全部', value: '' },
    { name: '审批中', value: 1 },
    { name: '已通过', value: 2 },
    { name: '已拒绝', value: 3 },
    { name: '已撤销', value: 4 }
  ]
};
const formItems = [
  { label: '模版名称', model: 'tplName', type: 'input', span: 6 },
  { label: '审批流名称', model: 'title', type: 'input', span: 6 },
  {
    label: '审批状态',
    model: 'instStatus',
    type: 'select',
    options: config.instStatusMap,
    span: 6
  },
  { label: '发起人', model: 'applyUserName', type: 'input', span: 6 },
  { label: '发起时间', model: 'submitTime', type: 'daterange', span: 6 },
  { label: '完成时间', model: 'finishTime', type: 'daterange', span: 6 },
  {
    type: 'button',
    buttonArr: [
      { message: '查询', type: 'primary', fun: 'searchTableInfo' },
      { message: '重置', type: 'warning', fun: 'resetTableInfo', params: { submitTime: ['', ''], finishTime: ['', ''] } }
    ],
    span: 12
  }
];
const getColumnsMap = (methods) => {
  return {
    tplName: {
      title: '模版名称',
      key: 'tplName',
      width: 120
    },
    title: {
      title: '审批单标题',
      key: 'title',
      minWidth: 120,
      render: (h, params) => {
        const { id, title } = params.row;
        return h('a', {
          on: {
            click: () => {
              methods.jumpApproval(id);
            }
          },
          domProps: {
            innerHTML: title && title.replace(';', '<br/>')
          }
        });
      }
    },
    submitTime: {
      title: '发起时间',
      key: 'submitTime',
      minWidth: 100
    },
    finishTime: {
      title: '完成时间',
      key: 'finishTime',
      minWidth: 100
    },
    applyUserName: {
      title: '发起人',
      key: 'applyUserName',
      minWidth: 100
    },
    auditUserName: {
      title: '审批人',
      key: 'auditUserName',
      minWidth: 100,
      render: (h, params) => {
        const { auditUserName } = params.row;
        return h('div', {
          style: { textAlign: 'left' },
          domProps: {
            innerHTML: auditUserName && auditUserName.replace(';', '<br/>')
          }
        });
      }
    },
    instStatus: {
      title: '审批状态',
      key: 'instStatus',
      minWidth: 100,
      render: (h, params) => {
        return h('div', util.getListMap(config.instStatusMap)[params.row.instStatus]);
      }
    },
    action: {
      title: '操作',
      align: 'left',
      key: 'action',
      minWidth: 100,
      fixed: 'right',
      render: (h, { row }) => {
        const buttonArr = [];
        const { instStatus, isTrans } = row;
        // buttonArr.push(
        //   h('CustomButton', {
        //     props: { type: 'success', size: 'small', permissionCode: authType.user.setRoleAuth },
        //     style: { margin: '4px' },
        //     on: {
        //       click: () => {
        //         methods.export(row);
        //       }
        //     }
        //   }, '导出')
        // );
        // if (instStatus == 1 && isTrans == 1) {
        if (instStatus == 1) {
          buttonArr.push(
            h('CustomButton', {
              props: { type: 'success', size: 'small', permissionCode: authType.dataManage.change },
              style: { margin: '4px' },
              on: {
                click: () => {
                  methods.transfer(row);
                }
              }
            }, '转交')
          );
        }
        return h('div', { style: { 'text-align': 'left' } }, buttonArr);
      }
    }
  };
};
const getColumns = (methods, noShowArr) => {
  const columnsMap = getColumnsMap(methods);
  const keyArr = Object.keys(columnsMap);
  const columns = [];
  keyArr.forEach(key => {
    if (!noShowArr || !noShowArr.includes(key)) {
      columns.push(columnsMap[key]);
    }
  });
  return columns;
};
export { formItems, getColumns, config };
